var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contextmenu"}},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"#!"},on:{"click":_vm.addNewFolder}},[_vm._v("Neuer Unterordner")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }